import iCard from './i-card.vue'

export default {
  install (Vue, options = {}) {
    Vue.component('i-card', iCard)
  }
}
